import { Link } from "react-router-dom";
import { CheckCircle, WarningOctagon } from "@phosphor-icons/react";
import { formatINR } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";
import { SEVERITY_STYLE } from "./constants";

export default function ActionableStrip({ items, summary }) {
    if (!items?.length) {
        return (
            <div className="reedos-card p-4 flex items-center gap-3 border-emerald-200 bg-emerald-50/50" data-testid="ledger-actionable-strip-empty">
                <CheckCircle size={18} weight="fill" className="text-emerald-600" />
                <div>
                    <div className="text-sm font-semibold text-emerald-900">All caught up</div>
                    <div className="text-[11px] text-emerald-800/80">No overdue invoices, no pending milestones, no open conversions.</div>
                </div>
            </div>
        );
    }
    return (
        <div className="reedos-card border-amber-300" data-testid="ledger-actionable-strip">
            <div className="px-5 py-3 border-b border-amber-200 bg-amber-50/60 flex items-center gap-3">
                <WarningOctagon size={16} weight="fill" className="text-amber-700" />
                <div className="flex-1">
                    <div className="reedos-eyebrow text-amber-900">Needs attention</div>
                    <div className="text-sm font-semibold text-slate-900">
                        {summary.overdue_invoices > 0 && <span data-testid="action-summary-overdue" className="mr-3">{summary.overdue_invoices} overdue invoice{summary.overdue_invoices !== 1 ? "s" : ""}</span>}
                        {summary.pending_milestones > 0 && <span data-testid="action-summary-pending" className="mr-3">{summary.pending_milestones} pending milestone{summary.pending_milestones !== 1 ? "s" : ""}</span>}
                        {summary.approved_not_converted > 0 && <span data-testid="action-summary-not-converted" className="mr-3">{summary.approved_not_converted} approved · no PO</span>}
                    </div>
                </div>
            </div>
            <ul className="divide-y divide-slate-100">
                {items.slice(0, 6).map((a, i) => (
                    <li key={i} className="px-5 py-2.5 flex items-center gap-3" data-testid={`action-item-${i}`}>
                        <span className={classJoin("inline-flex items-center rounded px-1.5 py-0.5 text-[9px] font-bold border", SEVERITY_STYLE[a.severity])}>
                            {a.severity.toUpperCase()}
                        </span>
                        <div className="min-w-0 flex-1">
                            <Link to={a.link_to || "#"} className="text-sm font-medium text-slate-900 hover:underline truncate block">
                                {a.title}
                            </Link>
                            <div className="text-[11px] text-slate-500 truncate">{a.subtitle}</div>
                        </div>
                        <div className="reedos-data text-sm font-semibold whitespace-nowrap text-slate-900">{formatINR(a.amount || 0)}</div>
                    </li>
                ))}
            </ul>
            {items.length > 6 && (
                <div className="px-5 py-2 text-[11px] text-slate-500 border-t border-slate-100">
                    +{items.length - 6} more action item{items.length - 6 !== 1 ? "s" : ""} below in the timeline
                </div>
            )}
        </div>
    );
}
